import React from "react";
import SubscriptionList from "../../../components/Pages/Subscription/Email/List";

const Subscription = () => {
  return (
    <div>
      <SubscriptionList />
    </div>
  );
};

export default Subscription;
